import { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  Stack,
  Button,
  Avatar,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import moment from "moment";
import { IoMdEye } from "react-icons/io";
//Import from project
import "../../../Style/pagestyle.scss";
import CreateIcon from "../../../Assets/create-icon.svg";
import EmptyData from "../../Include/EmptyData/EmptyData";
import LoadingPage from "../../../Utils/LoadingPage";
import StudentAction from "./StudentAction";
import useGetStudentByclassId from "../../../Hooks/useGetStudentByclassId";
import AssignStudentToClassForm from "./AssignStudentToClassForm";
import { AuthContext } from "../../../Context/AuthContext";
import { ButtonCreate, SearchTextField } from "../../../Utils/Component";
import ViewAttendnaceReport from "../Attendance/ViewAttendnaceReport";
import useWithDimension from "../../../Hooks/useWithDimension";

export default function Student({ classId, defaultTotalHour }) {
  // Change Language
  const { t } = useContext(AuthContext);
  const [isComplete, setIsComplete] = useState("studying");
  const { width } = useWithDimension();

  //
  const { loading, refetch, tableData, handleSearch } = useGetStudentByclassId({
    id: classId,
    isComplete,
  });

  //
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openView, setOpenView] = useState(false);
  const handleOpenView = () => setOpenView(true);
  const handleCloseView = () => setOpenView(false);

  // console.log("tableData:::", tableData);

  const handleCheckStatus = (valStatus) => {
    if (valStatus === "studying") {
      return t("thead_studying");
    } else if (valStatus === "complete") {
      return t("thead_completed");
    } else {
      return "";
    }
  };

  const handleCheckStatusColor = (valStatus) => {
    if (valStatus === "studying") {
      return "green";
    } else if (valStatus === "complete") {
      return "red";
    } else {
      return "";
    }
  };

  return (
    <div>
      {/* ================== Filters ================== */}
      <Box sx={{ marginTop: "10px" }}>
        <Grid container spacing={3} sx={{ minHeight: "100px" }}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_status")}
            </Typography>
            <FormControl fullWidth size="small" className="text-field">
              <Select
                value={isComplete}
                onChange={(e) => setIsComplete(e.target.value)}
              >
                <MenuItem value="all">{t("thead_all")}</MenuItem>
                <MenuItem value="studying">{t("thead_studying")}</MenuItem>
                <MenuItem value="complete">{t("thead_completed")}</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={4} lg={6} xl={8}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="right"
              sx={{ marginTop: "30px" }}
              // alignItems="flex-end"
            >
              <ButtonCreate
                handleOpen={handleOpenView}
                classBtn="btn-create"
                classIcon="icon-add"
                title={t("view_attendance")}
                icon={<IoMdEye />}
              />

              {/* <ButtonCreate
                handleOpen={handleOpen}
                classBtn="btn-create"
                classIcon="icon-add"
                title={t("modal_title_add_student")}
              /> */}

              <Box>
                {loading ? (
                  <Button
                    className={"btn-create"}
                    startIcon={
                      <img
                        src={CreateIcon}
                        alt="CreateIcon"
                        className={"icon-add"}
                      />
                    }
                  >
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    onClick={handleOpen}
                    className={"btn-create"}
                    startIcon={
                      <img
                        src={CreateIcon}
                        alt="CreateIcon"
                        className={"icon-add"}
                      />
                    }
                    sx={{ whiteSpace: "pre" }}
                  >
                    {t("modal_title_add_student")}
                  </Button>
                )}
              </Box>
            </Stack>

            {openView && (
              <ViewAttendnaceReport
                classId={classId}
                open={openView}
                handleClose={handleCloseView}
              />
            )}

            {open && (
              <AssignStudentToClassForm
                dialogTitle={"Create"}
                open={open}
                classId={classId}
                tableData={tableData}
                setRefetch={refetch}
                handleClose={handleClose}
                defaultTotalHour={defaultTotalHour}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="4%"
                >
                  {t("thead_no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="10%">
                  {t("thead_id")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="15%">
                  {t("thead_student")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="7%">
                  {t("thead_gender")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  align="center"
                >
                  {t("thead_date_of_birth")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_start_hour_date")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_end_hour_date")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_all")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_remain")}
                </TableCell>
                {/* <TableCell className={t("class-name-header-title")}>
                  {t("thead_starthourdate")}
                </TableCell> */}
                <TableCell className={t("class-name-header-title")}></TableCell>
                <TableCell
                  className={t("class-name-header-title-end")}
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={11}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={11} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        // console.log("row::", row)
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell
                              className={
                                row?.enrollmentId?.status === "complete"
                                  ? "body-cell-start-complete"
                                  : "body-cell-start"
                              }
                            >
                              {index + 1}
                            </TableCell>

                            <TableCell
                              className={
                                row?.enrollmentId?.status === "complete"
                                  ? "body-cell-complete"
                                  : "body-cell"
                              }
                            >
                              {row?.studentId}
                            </TableCell>

                            <TableCell
                              className={
                                row?.enrollmentId?.status === "complete"
                                  ? "body-cell-complete"
                                  : "body-cell"
                              }
                            >
                              <Stack direction="row" spacing={1.4}>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Avatar
                                    sx={{ width: 40, height: 40 }}
                                    alt={row?.studentName}
                                    src={row?.profile}
                                  />
                                </Stack>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Typography className="student-name">
                                    {row?.familyName + " " + row?.studentName}
                                  </Typography>
                                </Stack>
                              </Stack>
                            </TableCell>

                            <TableCell
                              className={
                                row?.enrollmentId?.status === "complete"
                                  ? "body-cell-complete"
                                  : "body-cell"
                              }
                            >
                              {row?.gender === "Male"
                                ? t("thead_male")
                                : t("thead_female")}
                            </TableCell>

                            <TableCell
                              className={
                                row?.enrollmentId?.status === "complete"
                                  ? "body-cell-complete"
                                  : "body-cell"
                              }
                              align="center"
                            >
                              {row?.dob &&
                                moment(row?.dob).format("DD MMM YYYY")}
                            </TableCell>

                            {/* <TableCell
                              className={
                                row?.enrollmentId?.status === "complete"
                                  ? "body-cell-complete"
                                  : "body-cell"
                              }
                            >
                              {row?.phoneNumber}
                            </TableCell> */}

                            <TableCell
                              className={
                                row?.enrollmentId?.status === "complete"
                                  ? "body-cell-complete"
                                  : "body-cell"
                              }
                              align="left"
                            >
                              {row?.startHourDate &&
                                moment(row?.startHourDate).format(
                                  "DD MMM YYYY",
                                )}
                            </TableCell>

                            <TableCell
                              className={
                                row?.enrollmentId?.status === "complete"
                                  ? "body-cell-complete"
                                  : "body-cell"
                              }
                              align="left"
                            >
                              {row?.endHourDate &&
                                moment(row?.endHourDate).format("DD MMM YYYY")}
                            </TableCell>

                            <TableCell
                              className={
                                row?.enrollmentId?.status === "complete"
                                  ? "body-cell-complete"
                                  : "body-cell"
                              }
                              sx={{
                                fontWeight: "bold",
                                color: "green",
                              }}
                            >
                              {row?.totalHour} {t("thead_hour")}
                            </TableCell>

                            <TableCell
                              className={
                                row?.enrollmentId?.status === "complete"
                                  ? "body-cell-complete"
                                  : "body-cell"
                              }
                              sx={{
                                fontWeight: "bold",
                                color:
                                  row?.totalHourRemain < 6 ? "red" : "orange",
                              }}
                            >
                              {row?.totalHourRemain} {t("thead_hour")}
                            </TableCell>

                            <TableCell
                              className={
                                row?.enrollmentId?.status === "complete"
                                  ? "body-cell-complete"
                                  : "body-cell"
                              }
                              sx={{
                                fontWeight: "bold",
                                color: handleCheckStatusColor(
                                  row?.enrollmentId?.status,
                                ),
                              }}
                            >
                              {handleCheckStatus(row?.enrollmentId?.status)}
                            </TableCell>

                            <TableCell
                              className={
                                row?.enrollmentId?.status === "complete"
                                  ? "body-cell-end-complete"
                                  : "body-cell-end"
                              }
                              align="right"
                            >
                              <StudentAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
